const ALL_CAPS_HEADER = /(?<!\p{L})(?=\p{Lu}+ : )/u;

export function splitBeforeAllCapsHeaders(text: string): string[] {
  return text.split(ALL_CAPS_HEADER);
}
